export const getters = {
  getContacts($state) {
    return $state.sortOrder.map(contactId => $state.records[contactId]);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getContact: $state => id => {
    const contact = $state.records[id];
    return contact || {};
  },
  getContactByAliasId: $state => alias => {
    if(!$state.records) return '';

    let contact = {};

    Object.keys($state.records).forEach(id => {
      const c = $state.records[id];
      if(c.identifier === alias) {
        contact = c;
        return;
      }
    });

    return contact;
  },
  getMeta: $state => {
    return $state.meta;
  },
  getAppliedContactFilters: _state => {
    return _state.appliedFilters;
  },
};
